import React, { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { limpiarNivelConfiguracion, obtenerNivelConfiguracion, editarNivelConfiguracion } from '../../../actions/configuracion';

const EditarNivel = ({ nivel, reestablecerNivel }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.educacion);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [nivelData, setNivelData] = useState({
        id: null,
        nombre: null, 
        orden: null
    });

    /* Editar nivel */
    const handleInputChange = ({ target }) => {
        setNivelData({
            ...nivelData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(nivelData.nombre && nivelData.orden){
            await setStatusProcesar(true);
            await dispatch(editarNivelConfiguracion(nivelData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setNivelData({
                id: null,
                nombre: null, 
                orden: null
            });

            setEditarModal(false);

            reestablecerNivel(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarNivelConfiguracion());
    }, []);

    useEffect(() => {
        if(nivel){
            setEditarModal(true);
            
            dispatch(obtenerNivelConfiguracion(nivel?._id));

            setNivelData({
                ...nivelData,
                id: nivel?._id
            });
        }
    }, [nivel]);

    useEffect(() => {
        if(detalles){
            setNivelData({
                ...nivelData,
                id: detalles?._id, 
                nombre: detalles?.nombre,
                orden: detalles?.orden
            });
        }
    }, [detalles]);

    return (
        <Fragment>
            <Modal show={editarModal} size="lg" backdrop="static" centered onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar nivel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="form-group mb-3 col-md-8">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={nivelData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group mb-3 col-md-4">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Orden" id="orden" name="orden" value={nivelData.orden} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="orden">Orden</label>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </Modal.Body>
                <Modal.Footer>
                    {
                        statusProcesar ?
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Editar</button>
                        :
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Editar</button>
                    }
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default EditarNivel;